/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import { authServiceConfig, EXECUTE_RESULT } from "@/constant/config";
import { pagesInfo } from "@/constant/index";

const environment = {
    TYPE: process.env.VUE_APP_TYPE,
};

export default {

    // Login
    authLogin: function (loginRawData) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.loginUrl,
                data: loginRawData,
                withCredentials: true,
            })
                .then(resp => {
                    try {
                        let resTemp = resp.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = resp.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                }).catch(err => {
                    reject(err);
                });
        });
    },

    // Register
    registerUser: function (registerForm) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.registerUserUrl,
                data: registerForm,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        console.log("🚀 ~ file: auth.js ~ line 90 ~ err", err)
                        console.log("🚀 ~ file: auth.js ~ line 90 ~ err", err)
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Forgot password
    forgotPasswordUser: function (forgotPasswordForm) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.forgotPasswordSubmitUrl,
                data: forgotPasswordForm,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Change password
    changePassword: function (changePasswordForm) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.changePasswordUrl,
                data: changePasswordForm,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get profile
    getProfileUser: function () {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getProfileUserUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Update profile
    updateProfileUser: function (userProfile) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.updateProfileUserUrl,
                data: userProfile,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get basic user information
    getBasicUserInformation: function () {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getBasicUserInformationUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get temp balance
    getTempBalance: function () {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getTempBalanceUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get parameter by type
    getParameterByType(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getParameterByTypeUrl.format(request),
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Logout
    logout(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.logoutUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get dashboard information machine
    getDashboardInformationMachine: function () {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getDashboardInformationMachineUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get dashboard information billing
    getDashboardInformationBilling: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getDashboardInformationBillingUrl.format(request),
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Re-Send email
    reSendEmail: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.reSendEmail,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Reactivate account
    reActivateAccount: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.reActivateAccount,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    retryUserInfomations: function (reactiveToken) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: `${authServiceConfig.retryUserInfomations}?token=${reactiveToken}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },
    reActivateAccountVerifyV2(reactiveFormData){
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.reActivateAccountVerifyV2,
                data: reactiveFormData,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        });
    },

    // Get ip info
    getIpInfo: function () {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getIpInfoUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    getEnableTfaInfoUrl() {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getEnableTfaInfoUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    postEnableTfaUrl(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.postEnableTfaUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    postDisableTfaUrl(request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: authServiceConfig.postDisableTfaUrl,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    getIsEnableTfaInfoUrl() {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: authServiceConfig.getIsEnableTfaInfoUrl,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    }
}